import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { RegionService } from '../proxy/planning/controllers/region.service';
import { Zone } from '../zone/zone';

FieldBuilder.setNamespace('Planning');

export const SUBREGION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Subregion.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Subregion.Code')
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('regionId', 'Entity.Region', RegionService)
    .required()
    .displayFromNested('region.name')
    .sortBy('region.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const SUBREGION_CONFIG = {
  entityName: 'Subregion',
  localizationKey: 'Planning::Entity.Subregion',
  permission: 'PlanningLocation.Subregions',
  fields: SUBREGION_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
